<div class="disponible-page">

  <!-- Breadcrumb -->
  <nav class="pay-breadcrumb">
    <span class="bc-item" (click)="volverPortal()">Portal</span>
    <span class="bc-sep">›</span>

    <ng-container [ngSwitch]="paso">

      <ng-container *ngSwitchCase="'cartera'">
        <span class="bc-item" (click)="irAQuePagar()">Gestiona tus pagos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item active">Regularizar cartera</span>
      </ng-container>

      <ng-container *ngSwitchCase="'creditos'">
        <span class="bc-item" (click)="irAQuePagar()">Gestiona tus pagos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item active">Pagar créditos</span>
      </ng-container>

      <ng-container *ngSwitchCase="'cuanto'">
        <span class="bc-item" (click)="irAQuePagar()">Gestiona tus pagos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item" *ngIf="!esCuota()" (click)="pStep('cartera')">Regularizar cartera</span>
        <span class="bc-item" *ngIf="esCuota()" (click)="pStep('creditos')">Pagar créditos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item active">¿Cuánto pagar?</span>
      </ng-container>

      <ng-container *ngSwitchCase="'procesando'">
        <span class="bc-item active">Procesando…</span>
      </ng-container>

      <ng-container *ngSwitchCase="'resultado'">
        <span class="bc-item active">Resultado</span>
      </ng-container>

      <ng-container *ngSwitchCase="'giro-monto'">
        <span class="bc-item" (click)="irAQuePagar()">Gestiona tus pagos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item active">Solicitar giro</span>
      </ng-container>

      <ng-container *ngSwitchCase="'giro-confirmar'">
        <span class="bc-item" (click)="irAQuePagar()">Gestiona tus pagos</span>
        <span class="bc-sep">›</span>
        <span class="bc-item" (click)="pStep('giro-monto')">Solicitar giro</span>
        <span class="bc-sep">›</span>
        <span class="bc-item active">Confirmar giro</span>
      </ng-container>

      <ng-container *ngSwitchCase="'giro-procesando'">
        <span class="bc-item active">Procesando…</span>
      </ng-container>

      <ng-container *ngSwitchCase="'giro-resultado'">
        <span class="bc-item active">Giro solicitado</span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <span class="bc-item active">Gestiona tus pagos</span>
      </ng-container>

    </ng-container>
  </nav>

  <div class="pay-layout">
    <div class="pay-main full-width">

      <button class="pay-back-btn" *ngIf="tieneVolver()" (click)="volverAtras()">
        <span class="material-symbols-outlined">arrow_back</span>
        Volver
      </button>

      <!-- PASO: GESTIONA TUS PAGOS -->
      <div class="p-step" *ngIf="paso === 'que-pagar'">
        <div class="gp-wrap">

          <h1 class="gp-title">Gestiona tus pagos</h1>
          <p class="gp-sub">Usa tu disponible para pagar tus facturas y otras obligaciones.</p>

          <div class="gp-disp">
            <div class="gp-disp-eyebrow">
              <span class="gp-disp-dot"></span>
              Tu disponible
            </div>
            <div class="gp-disp-amount">{{ fmt(disponible) }}</div>
            <div class="gp-disp-meta">
              <div class="gp-disp-meta-item">
                <div class="gp-disp-meta-label">Facturas pendientes</div>
                <div class="gp-disp-meta-val">{{ pendientes().length }} factura{{ pendientes().length !== 1 ? 's' : '' }}</div>
              </div>
              <div class="gp-disp-meta-sep"></div>
              <div class="gp-disp-meta-item">
                <div class="gp-disp-meta-label">Deuda total</div>
                <div class="gp-disp-meta-val">{{ fmt(deudaTotal()) }}</div>
              </div>
            </div>
          </div>

          <p class="gp-sub" *ngIf="errorCartera">{{ errorCartera }} <a (click)="cargarCartera()" style="cursor:pointer;">Reintentar</a></p>

          <div class="gp-section-label">¿Qué quieres hacer?</div>

          <div class="gp-main-card" (click)="pStep('cartera')">
            <div class="gp-main-card-icon">
              <span class="material-symbols-outlined">account_balance</span>
            </div>
            <div class="gp-main-card-body">
              <div class="gp-main-card-title">Regularizar cartera</div>
              <div class="gp-main-card-desc">Paga tus facturas pendientes usando tu disponible.</div>
            </div>
            <div class="gp-main-card-arrow">
              <span class="material-symbols-outlined">arrow_forward</span>
            </div>
          </div>

          <!-- El crédito es otro producto, con entrada propia: siempre se ve, y se activa
               solo si el cliente tiene un crédito con cuotas por pagar. -->
          <div class="gp-main-card" [class.gp-main-card-disabled]="creditosPendientes().length === 0"
            (click)="creditosPendientes().length > 0 && pStep('creditos')">
            <div class="gp-main-card-icon">
              <span class="material-symbols-outlined">payments</span>
            </div>
            <div class="gp-main-card-body">
              <div class="gp-main-card-title">Pagar créditos</div>
              <div class="gp-main-card-desc">
                <!-- "No tienes créditos" sólo cuando la cartera llegó: cargando o con error no se sabe. -->
                {{ creditosPendientes().length > 0 ? 'Paga las cuotas de tus créditos usando tu disponible.'
                   : cargandoCartera ? 'Revisando tus créditos…'
                   : errorCartera ? 'No pudimos revisar tus créditos.'
                   : 'No tienes créditos con cuotas por pagar.' }}
              </div>
            </div>
            <div class="gp-main-card-arrow" *ngIf="creditosPendientes().length > 0">
              <span class="material-symbols-outlined">arrow_forward</span>
            </div>
          </div>

          <div class="gp-transfer-card gp-transfer-card-disabled">
            <div class="gp-transfer-header">
              <div class="gp-main-card-icon gp-transfer-icon">
                <span class="material-symbols-outlined">swap_horiz</span>
              </div>
              <div class="gp-transfer-body">
                <div class="gp-main-card-title">Pagar por transferencia</div>
                <div class="gp-main-card-desc">Transfiere a nuestra cuenta o carga tu comprobante si ya realizaste el pago.</div>
              </div>
              <div class="gp-pronto">Próximamente</div>
            </div>
          </div>

          <div class="gp-section-label gp-section-label-top">Otras opciones</div>
          <div class="gp-otras-grid">
            <div class="gp-otra-card">
              <div class="gp-otra-icon"><span class="material-symbols-outlined">store</span></div>
              <div class="gp-otra-label">Pago a proveedores</div>
              <div class="gp-pronto">Próximamente</div>
            </div>
            <div class="gp-otra-card">
              <div class="gp-otra-icon"><span class="material-symbols-outlined">people</span></div>
              <div class="gp-otra-label">Pago remuneraciones</div>
              <div class="gp-pronto">Próximamente</div>
            </div>
            <div class="gp-otra-card">
              <div class="gp-otra-icon"><span class="material-symbols-outlined">swap_horiz</span></div>
              <div class="gp-otra-label">Transferencia</div>
              <div class="gp-pronto">Próximamente</div>
            </div>
            <div class="gp-otra-card">
              <div class="gp-otra-icon"><span class="material-symbols-outlined">gavel</span></div>
              <div class="gp-otra-label">Pago TGR / SII</div>
              <div class="gp-pronto">Próximamente</div>
            </div>
          </div>

        </div>
      </div>

      <!-- PASO: REGULARIZAR CARTERA -->
      <div class="p-step" *ngIf="paso === 'cartera'">
        <div class="rc-wrap">

          <h1 class="pay-step-title">Regularizar cartera</h1>
          <p class="pay-step-sub">Selecciona la factura que quieres pagar y define el monto a abonar.</p>

          <div class="rc-toolbar">
            <div class="rc-disp-chip">
              <span class="rc-disp-chip-dot"></span>
              <span class="rc-disp-chip-label">Tu disponible</span>
              <span class="rc-disp-chip-val">{{ fmt(disponible) }}</span>
            </div>
            <button class="rc-btn-pagar-main" [disabled]="!facturaSeleccionada" (click)="continuarDesdeCartera()">
              Pagar factura
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>

          <div class="rc-footnote" *ngIf="cargandoCartera">
            Cargando tu cartera…
          </div>

          <div class="rc-footnote" *ngIf="!cargandoCartera && errorCartera">
            {{ errorCartera }}
            <a (click)="cargarCartera()" style="cursor:pointer;">Reintentar</a>
          </div>

          <ng-container *ngIf="!cargandoCartera && !errorCartera">

            <ng-container *ngFor="let grupo of grupos">
              <ng-container *ngIf="facturasPorGrupo(grupo.key).length > 0">

                <div class="rc-group-label" [ngClass]="grupo.colorClass">{{ grupo.label }}</div>

                <div class="rc-card" *ngFor="let f of facturasPorGrupo(grupo.key)"
                  [class.selected]="facturaSeleccionada?.id === f.id"
                  (click)="seleccionarFactura(f)">
                  <div class="rc-radio" [class.checked]="facturaSeleccionada?.id === f.id"></div>
                  <div class="rc-card-info">
                    <div class="rc-card-head">
                      <span class="rc-factura-num">Factura {{ f.docto }}</span>
                      <span class="badge" [ngClass]="badgeClass(f)">{{ badgeTexto(f) }}</span>
                    </div>
                    <div class="rc-deudor">{{ f.deudor }}</div>
                    <div class="rc-op">Operación {{ f.operacion }}</div>
                  </div>
                  <div class="rc-card-right">
                    <div class="rc-deuda-block">
                      <div class="rc-deuda-label">Deuda</div>
                      <div class="rc-deuda-val">{{ fmt(f.total) }}</div>
                    </div>
                  </div>
                </div>

              </ng-container>
            </ng-container>

            <div class="rc-footnote" *ngIf="pendientes().length === 0">
              <span class="material-symbols-outlined">task_alt</span>
              No tienes facturas pendientes por regularizar.
            </div>

          </ng-container>

        </div>
      </div>

      <!-- PASO: PAGAR CRÉDITOS — producto aparte de las facturas, nunca en la misma lista -->
      <div class="p-step" *ngIf="paso === 'creditos'">
        <div class="rc-wrap">

          <h1 class="pay-step-title">Pagar créditos</h1>
          <p class="pay-step-sub">Selecciona la cuota que quieres pagar y define el monto.</p>

          <div class="rc-toolbar">
            <div class="rc-disp-chip">
              <span class="rc-disp-chip-dot"></span>
              <span class="rc-disp-chip-label">Tu disponible</span>
              <span class="rc-disp-chip-val">{{ fmt(disponible) }}</span>
            </div>
            <button class="rc-btn-pagar-main" [disabled]="!facturaSeleccionada" (click)="continuarDesdeCartera()">
              Pagar cuota
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>

          <div class="rc-footnote" *ngIf="cargandoCartera">
            Cargando tus créditos…
          </div>

          <div class="rc-footnote" *ngIf="!cargandoCartera && errorCartera">
            {{ errorCartera }}
            <a (click)="cargarCartera()" style="cursor:pointer;">Reintentar</a>
          </div>

          <ng-container *ngIf="!cargandoCartera && !errorCartera">
            <ng-container *ngFor="let c of creditosPendientes()">

              <div class="rc-group-label">Crédito {{ c.credito }} · {{ fmt(c.deudaTotal) }}</div>

              <div class="rc-card" *ngFor="let q of cuotasPendientes(c)"
                [class.selected]="facturaSeleccionada?.id === q.id"
                (click)="seleccionarFactura(q)">
                <div class="rc-radio" [class.checked]="facturaSeleccionada?.id === q.id"></div>
                <div class="rc-card-info">
                  <div class="rc-card-head">
                    <span class="rc-factura-num">Cuota {{ q.numero }} de {{ q.numCuotas }}</span>
                    <span class="badge" [ngClass]="badgeClass(q)">{{ badgeTexto(q) }}</span>
                  </div>
                  <div class="rc-op rc-op-mora" *ngIf="q.interesMora > 0">Incluye {{ fmt(q.interesMora) }} de mora</div>
                </div>
                <div class="rc-card-right">
                  <div class="rc-deuda-block">
                    <div class="rc-deuda-label">Deuda</div>
                    <div class="rc-deuda-val">{{ fmt(q.total) }}</div>
                  </div>
                </div>
              </div>

            </ng-container>

            <div class="rc-footnote" *ngIf="creditosPendientes().length === 0">
              <span class="material-symbols-outlined">task_alt</span>
              No tienes cuotas de crédito pendientes.
            </div>
          </ng-container>

        </div>
      </div>

      <!-- PASO: CUÁNTO PAGAR -->
      <div class="p-step" *ngIf="paso === 'cuanto' && facturaSeleccionada">
        <div class="flow-wrap">

          <h1 class="pay-step-title">¿Cuánto quieres pagar?</h1>
          <p class="pay-step-sub">Ingresa el monto que deseas pagar o abonar.</p>

          <div class="cq-factura-ctx">
            <div class="cq-factura-ctx-main">
              <div class="cq-ctx-left">
                <div class="cq-ctx-head">
                  <span class="cq-ctx-num" *ngIf="!esCuota()">Factura {{ facturaSeleccionada.docto }}</span>
                  <span class="cq-ctx-num" *ngIf="esCuota()">Cuota {{ facturaSeleccionada.numero }} de {{ facturaSeleccionada.numCuotas }}</span>
                  <span class="badge" [ngClass]="badgeClass(facturaSeleccionada)">{{ badgeTexto(facturaSeleccionada) }}</span>
                </div>
                <div class="cq-ctx-empresa" *ngIf="!esCuota()">{{ facturaSeleccionada.deudor }}</div>
                <div class="cq-ctx-empresa" *ngIf="esCuota()">Crédito {{ facturaSeleccionada.credito }}</div>
              </div>
              <div class="cq-ctx-right">
                <div class="cq-ctx-deuda-label">Deuda total</div>
                <div class="cq-ctx-deuda-val">{{ fmt(facturaSeleccionada.total) }}</div>
              </div>
            </div>

            <!-- Siempre a la vista: saldo, mora y mínimo son lo que se necesita para decidir
                 cuánto pagar, y escondidos detrás de "Ver más" obligaban a abrir la tarjeta. -->
            <div class="cq-detalle-extra cq-detalle-extra-open">
              <div class="cq-detalle-row" *ngIf="!esCuota()">
                <span class="cq-detalle-label">Operación</span>
                <span class="cq-detalle-val">{{ facturaSeleccionada.operacion }}</span>
              </div>
              <div class="cq-detalle-row">
                <span class="cq-detalle-label">{{ esCuota() ? 'Saldo de la cuota' : 'Monto Neto' }}</span>
                <span class="cq-detalle-val">{{ fmt(facturaSeleccionada.deudaNeta) }}</span>
              </div>
              <div class="cq-detalle-row">
                <span class="cq-detalle-label">Monto de la Mora</span>
                <span class="cq-detalle-val cq-detalle-val-error">{{ facturaSeleccionada.interesMora > 0 ? fmt(facturaSeleccionada.interesMora) : '—' }}</span>
              </div>
              <div class="cq-detalle-row" *ngIf="facturaSeleccionada.minimo > 0">
                <span class="cq-detalle-label">Monto mínimo a pagar</span>
                <span class="cq-detalle-val">{{ fmt(facturaSeleccionada.minimo) }}</span>
              </div>
            </div>
          </div>

          <div class="cq-monto-section">
            <div class="cq-monto-label">Ingresa un monto a pagar</div>
            <div class="cq-monto-input-wrap">
              <span class="cq-monto-prefix">$</span>
              <input type="text" inputmode="numeric" placeholder="0"
                #montoInputEl
                class="cq-monto-input editable"
                [value]="montoInput"
                (input)="onMontoInput(montoInputEl)">
            </div>
            <div class="cq-monto-error" *ngIf="montoError">{{ montoError }}</div>
          </div>

          <div class="cq-aviso-mora" *ngIf="disponibleNoCubreMora()">
            Tu disponible ({{ fmt(disponible) }}) no alcanza para pagar la mora de {{ esCuota() ? 'esta cuota' : 'esta factura' }}.
            Para pagar necesitas al menos {{ fmt(facturaSeleccionada.minimo) }}.
          </div>

          <div class="cq-opciones">
            <div class="cq-opcion" [class.selected]="opcionSeleccionada === 'total'" (click)="seleccionarOpcionMonto('total')">
              <div class="cq-op-radio" [class.checked]="opcionSeleccionada === 'total'"></div>
              <div class="cq-op-body">
                <div class="cq-op-title">Pagar el total</div>
                <div class="cq-op-desc">{{ fmt(facturaSeleccionada.total) }}</div>
              </div>
            </div>
            <div class="cq-opcion" *ngIf="facturaSeleccionada.minimo > 0" [class.selected]="opcionSeleccionada === 'mora'" (click)="seleccionarOpcionMonto('mora')">
              <div class="cq-op-radio" [class.checked]="opcionSeleccionada === 'mora'"></div>
              <div class="cq-op-body">
                <div class="cq-op-title">Pagar solo la mora</div>
                <div class="cq-op-desc">{{ fmt(facturaSeleccionada.minimo) }}</div>
              </div>
            </div>
            <div class="cq-opcion" [class.selected]="opcionSeleccionada === 'abono'" (click)="seleccionarOpcionMonto('abono')">
              <div class="cq-op-radio" [class.checked]="opcionSeleccionada === 'abono'"></div>
              <div class="cq-op-body">
                <div class="cq-op-title">Realizar un abono</div>
                <div class="cq-op-desc">{{ facturaSeleccionada.minimo > 0 ? 'Ingresa el monto que quieres pagar, desde ' + fmt(facturaSeleccionada.minimo) + '.' : 'Ingresa el monto que quieres pagar.' }}</div>
              </div>
            </div>
          </div>

          <!-- La gestión de cobranza es de las facturas: no aplica a una cuota de crédito. -->
          <div class="cq-gestion-cobranza" *ngIf="opcionSeleccionada === 'total' && !esCuota()">
            <div class="cq-gestion-cobranza-titulo">Quiero que sigan gestionando la cobranza de esta factura.</div>
            <mat-slide-toggle
              class="cq-toggle-gestion"
              [checked]="needGestionSeleccionado"
              (change)="toggleNeedGestionSeleccion()">
            </mat-slide-toggle>
          </div>

          <div class="cq-resumen">
            <div class="cq-res-row" *ngIf="opcionSeleccionada === 'abono' && montoParseado() > 0 && saldoDespues() > 0">
              <span class="cq-res-label">Quedará un saldo pendiente</span>
              <span class="cq-res-val">{{ fmt(saldoDespues()) }}</span>
            </div>
            <div class="cq-res-row cq-res-highlight">
              <span class="cq-res-label">Disponible post pago</span>
              <span class="cq-res-val">{{ montoParseado() > 0 ? fmt(disponibleDespues()) : '—' }}</span>
            </div>
          </div>

          <div class="cq-cta-row">
            <button class="btn-p" [disabled]="disponibleNoCubreMora()" (click)="confirmarPago()">
              Confirmar pago <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>

        </div>
      </div>

      <!-- PASO: PROCESANDO -->
      <div class="p-step" *ngIf="paso === 'procesando'">
        <div class="loading-center">
          <div class="spinner"></div>
          <div class="loading-title">Procesando pago</div>
          <div class="loading-sub">Un momento por favor…</div>
        </div>
      </div>

      <!-- PASO: RESULTADO -->
      <div class="p-step" *ngIf="paso === 'resultado'">
        <div class="resultado-wrap">

          <div class="res-icon" [class.res-icon-abono]="!esTotal">
            <span class="material-symbols-outlined">{{ esTotal ? 'check_circle' : 'savings' }}</span>
          </div>

          <div class="res-eyebrow" [class.res-eyebrow-abono]="!esTotal">{{ esTotal ? 'Pago realizado' : 'Abono realizado' }}</div>
          <div class="res-title">
            <ng-container *ngIf="!esCuota()">{{ todoRegularizado() ? 'Tu cuenta quedó regularizada.' : (esTotal ? 'Regularizaste esta factura.' : 'Realizaste un abono a tu deuda.') }}</ng-container>
            <ng-container *ngIf="esCuota()">{{ todoRegularizado() ? 'Terminaste de pagar tu crédito.' : (esTotal ? 'Pagaste la cuota ' + facturaSeleccionada?.numero + ' de tu crédito.' : 'Realizaste un abono a tu cuota.') }}</ng-container>
          </div>

          <div class="res-rows">
            <div class="res-row">
              <div>
                <div class="res-row-label">{{ esTotal ? 'Pagaste' : 'Abonaste' }}</div>
                <div class="res-row-val">{{ fmt(montoAPagar) }}</div>
              </div>
            </div>
            <div class="res-row" *ngIf="!esTotal && facturaSeleccionada">
              <div>
                <div class="res-row-label">Saldo pendiente</div>
                <div class="res-row-val res-row-val-sm res-row-val-error">{{ fmt(facturaSeleccionada.saldoPendiente) }}</div>
              </div>
            </div>
            <div class="res-row">
              <div>
                <div class="res-row-label">Disponible restante</div>
                <div class="res-row-val res-row-val-sm res-row-val-muted">{{ fmt(disponible) }}</div>
              </div>
            </div>
          </div>

          <div class="cq-gestion-cobranza-error" *ngIf="needGestionError">{{ needGestionError }}</div>

          <div class="res-actions">
            <button class="btn-p" *ngIf="quedanPendientes(facturaSeleccionada?.tipo ?? 'factura')" (click)="pagarOtra()">
              {{ esCuota() ? 'Pagar otra cuota' : 'Pagar otra factura' }} <span class="material-symbols-outlined">arrow_forward</span>
            </button>
            <button class="btn-link" (click)="volverPortal()">Volver al portal</button>
          </div>

        </div>
      </div>

      <!-- PASO: SOLICITAR GIRO -->
      <div class="p-step" *ngIf="paso === 'giro-monto'">
        <div class="flow-wrap">

          <h1 class="pay-step-title">Solicitar giro</h1>
          <p class="pay-step-sub">Gira tu disponible a una cuenta bancaria de tu empresa.</p>

          <div class="gp-disp" style="margin-bottom: 24px;">
            <div class="gp-disp-eyebrow">
              <span class="gp-disp-dot"></span>
              Disponible para girar
            </div>
            <div class="gp-disp-amount">{{ fmt(disponible) }}</div>
          </div>

          <div class="cq-monto-section">
            <div class="cq-monto-label">¿Cuánto quieres girar?</div>
            <div class="cq-monto-input-wrap">
              <span class="cq-monto-prefix">$</span>
              <input type="text" inputmode="numeric" placeholder="0"
                #montoGiroInputEl
                class="cq-monto-input editable"
                [value]="montoGiroInput"
                (input)="onMontoGiroInput(montoGiroInputEl)">
            </div>
            <div class="cq-monto-error" *ngIf="montoGiroError">{{ montoGiroError }}</div>
          </div>

          <div class="cq-opciones">
            <div class="cq-opcion" [class.selected]="girarTodo" (click)="girarTodo = !girarTodo; onToggleGirarTodo()">
              <div class="cq-op-radio" [class.checked]="girarTodo"></div>
              <div class="cq-op-body">
                <div class="cq-op-title">Girar todo</div>
                <div class="cq-op-desc">Girar todo el monto disponible.</div>
              </div>
            </div>
          </div>

          <div class="cq-resumen">
            <div class="cq-res-row cq-res-highlight">
              <span class="cq-res-label">Disponible post giro</span>
              <span class="cq-res-val">{{ fmt(disponiblePostGiro()) }}</span>
            </div>
          </div>

          <div class="gp-section-label gp-section-label-top">Cuenta destino</div>

          <div class="rc-footnote" *ngIf="cargandoCuentas">Cargando tus cuentas bancarias…</div>

          <div class="rc-footnote" *ngIf="!cargandoCuentas && errorCuentas">
            {{ errorCuentas }}
            <a (click)="cargarCuentasBancarias()" style="cursor:pointer;">Reintentar</a>
          </div>

          <div class="rc-footnote" *ngIf="!cargandoCuentas && !errorCuentas && cuentasBancarias.length === 0">
            <span class="material-symbols-outlined">account_balance</span>
            No tienes cuentas bancarias registradas.
            <a (click)="irAAgregarCuenta()" style="cursor:pointer;">Agregar cuenta bancaria</a>
          </div>

          <ng-container *ngIf="!cargandoCuentas && !errorCuentas && cuentasBancarias.length > 0">
            <div class="rc-card" *ngFor="let c of cuentasBancarias"
              [class.selected]="cuentaSeleccionada?.id === c.id"
              (click)="seleccionarCuenta(c)">
              <div class="rc-radio" [class.checked]="cuentaSeleccionada?.id === c.id"></div>
              <div class="rc-card-info">
                <div class="rc-card-head">
                  <span class="rc-factura-num">{{ c.bank.name }}</span>
                  <span class="badge badge-vencer" *ngIf="c.is_primary">Principal</span>
                </div>
                <div class="rc-deudor">{{ c.tipo_cuenta }} · •••• {{ c.number.slice(-4) }}</div>
              </div>
            </div>
          </ng-container>

          <a class="agregar-cuenta-link" *ngIf="!cargandoCuentas && !errorCuentas && cuentasBancarias.length > 0" (click)="irAAgregarCuenta()" style="cursor:pointer;">
            <span class="material-symbols-outlined">add_circle</span>
            Agregar otra cuenta bancaria
          </a>

          <div class="cq-cta-row">
            <button class="btn-p" [disabled]="!puedeContinuarGiro()" (click)="continuarGiro()">
              Continuar <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>

        </div>
      </div>

      <!-- PASO: CONFIRMAR GIRO -->
      <div class="p-step" *ngIf="paso === 'giro-confirmar' && cuentaSeleccionada">
        <div class="flow-wrap">

          <h1 class="pay-step-title">Confirmar giro</h1>
          <p class="pay-step-sub">Revisa los detalles antes de confirmar.</p>

          <div class="cq-factura-ctx">
            <div class="cq-factura-ctx-main">
              <div class="cq-ctx-left">
                <div class="cq-ctx-head">
                  <span class="cq-ctx-num">Monto a girar</span>
                </div>
                <div class="cq-ctx-empresa">{{ cuentaSeleccionada.bank.name }} · •••• {{ cuentaSeleccionada.number.slice(-4) }}</div>
              </div>
              <div class="cq-ctx-right">
                <div class="cq-ctx-deuda-label">&nbsp;</div>
                <div class="cq-ctx-deuda-val">{{ fmt(montoAGirar) }}</div>
              </div>
            </div>
          </div>

          <div class="cq-resumen">
            <div class="cq-res-row">
              <span class="cq-res-label">Tiempo estimado</span>
              <span class="cq-res-val">Mismo día hábil</span>
            </div>
            <div class="cq-res-row cq-res-highlight">
              <span class="cq-res-label">Disponible post giro</span>
              <span class="cq-res-val">{{ fmt(disponible - montoAGirar) }}</span>
            </div>
          </div>

          <div class="cq-cta-row">
            <button class="btn-p" (click)="confirmarGiro()">
              Confirmar giro <span class="material-symbols-outlined">check</span>
            </button>
          </div>

        </div>
      </div>

      <!-- PASO: PROCESANDO GIRO -->
      <div class="p-step" *ngIf="paso === 'giro-procesando'">
        <div class="loading-center">
          <div class="spinner"></div>
          <div class="loading-title">Solicitando giro</div>
          <div class="loading-sub">Un momento por favor…</div>
        </div>
      </div>

      <!-- PASO: GIRO SOLICITADO -->
      <div class="p-step" *ngIf="paso === 'giro-resultado' && cuentaSeleccionada">
        <div class="resultado-wrap">

          <div class="res-icon">
            <span class="material-symbols-outlined">account_balance</span>
          </div>

          <div class="res-eyebrow">Giro en proceso</div>
          <div class="res-title">Tu giro está siendo procesado.</div>

          <div class="res-rows">
            <div class="res-row">
              <div>
                <div class="res-row-label">Monto solicitado</div>
                <div class="res-row-val">{{ fmt(montoAGirar) }}</div>
              </div>
            </div>
            <div class="res-row">
              <div>
                <div class="res-row-label">Cuenta destino</div>
                <div class="res-row-val res-row-val-sm">{{ cuentaSeleccionada.bank.name }} · •••• {{ cuentaSeleccionada.number.slice(-4) }}</div>
              </div>
            </div>
            <div class="res-row">
              <div>
                <div class="res-row-label">Disponible</div>
                <div class="res-row-val res-row-val-sm res-row-val-muted">{{ fmt(disponible) }}</div>
              </div>
            </div>
          </div>

          <p class="drawer-section-desc" style="text-align:center;margin-bottom:20px;">
            El dinero llegará a tu cuenta el mismo día hábil si lo solicitas antes de las 14:00 hrs.
          </p>

          <div class="res-actions">
            <button class="btn-link" (click)="volverPortal()">Volver al portal</button>
          </div>

        </div>
      </div>

    </div>
  </div>

  <!-- ─── DRAWER: PAGAR POR TRANSFERENCIA ─── -->
  <!-- Este contenedor se mueve a document.body en ngAfterViewInit (ver .ts)
       para escapar del contexto de apilamiento del header de la app. -->
  <div #drawerRoot class="disponible-page">

  <div class="drawer-overlay" *ngIf="drawerAbierto" (click)="cerrarDrawer()"></div>

  <div class="drawer" [class.drawer-open]="drawerAbierto">

    <div class="drawer-header">
      <button class="drawer-back" *ngIf="drawerEstado !== 'datos' && drawerEstado !== 'loader' && drawerEstado !== 'verificacion'" (click)="drawerVolver()">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>
      <span class="drawer-title">
        <ng-container [ngSwitch]="drawerEstado">
          <ng-container *ngSwitchCase="'datos'">Pagar por transferencia</ng-container>
          <ng-container *ngSwitchCase="'comprobante'">Subir comprobante</ng-container>
          <ng-container *ngSwitchCase="'facturas'">Seleccionar factura</ng-container>
          <ng-container *ngSwitchCase="'monto'">¿Cuánto quieres pagar?</ng-container>
          <ng-container *ngSwitchCase="'verificacion'">Comprobante recibido</ng-container>
        </ng-container>
      </span>
      <button class="drawer-close" (click)="cerrarDrawer()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="drawer-body">

      <!-- ESTADO: DATOS BANCARIOS -->
      <div *ngIf="drawerEstado === 'datos'">

        <div class="drawer-section">
          <div class="drawer-section-label">1. Realiza la transferencia</div>
          <p class="drawer-section-desc">Transfiere a la cuenta de Simpli desde tu cuenta bancaria empresarial.</p>

          <div class="drawer-bank-card">
            <div class="drawer-bank-row">
              <span class="drawer-bank-label">Banco</span><span class="drawer-bank-val">Banco BICE</span>
            </div>
            <div class="drawer-bank-row">
              <span class="drawer-bank-label">N.º de cuenta corriente</span><span class="drawer-bank-val">01-39940-3</span>
            </div>
            <div class="drawer-bank-row">
              <span class="drawer-bank-label">Razón Social</span><span class="drawer-bank-val">SIMPLI S.A.</span>
            </div>
            <div class="drawer-bank-row drawer-bank-row-last">
              <span class="drawer-bank-label">RUT</span><span class="drawer-bank-val">76.865.845-5</span>
            </div>
          </div>

          <button class="drawer-copy-btn" (click)="drawerCopiarDatos()">
            <span class="material-symbols-outlined" [class.drawer-copy-icon-ok]="drawerCopiado">{{ drawerCopiado ? 'check_circle' : 'content_copy' }}</span>
            {{ drawerCopiado ? 'Copiado' : 'Copiar todo' }}
          </button>
        </div>

        <div class="drawer-divider"></div>

        <div class="drawer-section">
          <div class="drawer-section-label">2. ¿Ya realizaste la transferencia?</div>
          <p class="drawer-section-desc">Carga tu comprobante para que podamos validar tu pago.</p>

          <button class="drawer-primary-btn" (click)="drawerIrComprobante()">
            <span class="material-symbols-outlined">upload_file</span>
            Cargar comprobante
          </button>
        </div>

        <div class="drawer-divider"></div>

        <div class="drawer-section">
          <button class="drawer-secondary-btn">
            <span class="material-symbols-outlined">add_circle_outline</span>
            Asociar cuenta de tu empresa
          </button>
          <p class="drawer-hint-center">Nos ayuda a identificar tus depósitos y hacer el match automáticamente</p>
        </div>

      </div>

      <!-- ESTADO: SUBIR COMPROBANTE -->
      <div *ngIf="drawerEstado === 'comprobante'">
        <p class="drawer-section-desc drawer-section-desc-top">
          Si ya realizaste la transferencia y no aparece tu disponible, sube el comprobante para que podamos validarla.
        </p>

        <input type="file" #drawerFileInput accept=".jpg,.jpeg,.png,.pdf" style="display:none" (change)="drawerArchivoSeleccionado($event)">

        <div class="drawer-upload-zone" [class.drawer-upload-zone-done]="drawerArchivoSubido" (click)="drawerFileInput.click()">
          <ng-container *ngIf="!drawerArchivoSubido">
            <span class="material-symbols-outlined drawer-upload-icon">upload_file</span>
            <div class="drawer-upload-title">Toca para subir</div>
            <div class="drawer-upload-sub">JPG, PNG o PDF — máx. 10 MB</div>
          </ng-container>
          <ng-container *ngIf="drawerArchivoSubido">
            <span class="material-symbols-outlined drawer-upload-icon drawer-upload-icon-ok">check_circle</span>
            <div class="drawer-upload-title drawer-upload-title-ok">{{ drawerArchivoNombre }}</div>
            <div class="drawer-upload-sub">Toca para cambiar</div>
          </ng-container>
        </div>
      </div>

      <!-- ESTADO: SELECCIÓN DE FACTURA -->
      <div *ngIf="drawerEstado === 'facturas'">
        <div class="drawer-facturas-title">Selecciona la factura a pagar</div>
        <div class="drawer-facturas-sub">Indica a qué factura quieres imputar la transferencia.</div>

        <div class="drawer-archivo-chip">
          <span class="material-symbols-outlined">attach_file</span>
          <span>{{ drawerArchivoNombre }}</span>
        </div>

        <ng-container *ngFor="let grupo of grupos">
          <ng-container *ngIf="facturasPorGrupo(grupo.key).length > 0">
            <div class="rc-group-label rc-group-label-sm" [ngClass]="grupo.colorClass">{{ grupo.label }}</div>
            <div class="rc-card rc-card-sm" *ngFor="let f of facturasPorGrupo(grupo.key)"
              [class.selected]="drawerFacturaSeleccionada?.id === f.id"
              (click)="drawerSeleccionarFactura(f)">
              <div class="rc-radio rc-radio-sm" [class.checked]="drawerFacturaSeleccionada?.id === f.id"></div>
              <div class="rc-card-info">
                <div class="rc-card-head">
                  <span class="rc-factura-num rc-factura-num-sm">Factura {{ f.docto }}</span>
                  <span class="badge badge-sm" [ngClass]="badgeClass(f)">{{ badgeTexto(f) }}</span>
                </div>
                <div class="rc-deudor rc-deudor-sm">{{ f.deudor }}</div>
              </div>
              <div class="rc-card-right">
                <div class="rc-deuda-block">
                  <div class="rc-deuda-val rc-deuda-val-sm">{{ fmt(f.total) }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- ESTADO: ¿CUÁNTO QUIERES PAGAR? -->
      <div *ngIf="drawerEstado === 'monto' && drawerFacturaSeleccionada">
        <div class="cq-factura-ctx">
          <div class="cq-factura-ctx-main">
            <div class="cq-ctx-left">
              <div class="cq-ctx-head">
                <span class="cq-ctx-num">Factura {{ drawerFacturaSeleccionada.docto }}</span>
                <span class="badge" [ngClass]="badgeClass(drawerFacturaSeleccionada)">{{ badgeTexto(drawerFacturaSeleccionada) }}</span>
              </div>
              <div class="cq-ctx-empresa">{{ drawerFacturaSeleccionada.deudor }}</div>
            </div>
            <div class="cq-ctx-right">
              <div class="cq-ctx-deuda-label">Deuda total</div>
              <div class="cq-ctx-deuda-val">{{ fmt(drawerFacturaSeleccionada.total) }}</div>
            </div>
          </div>
        </div>

        <div class="cq-monto-section">
          <div class="cq-monto-label">Ingresa un monto a pagar</div>
          <div class="cq-monto-input-wrap">
            <span class="cq-monto-prefix">$</span>
            <input type="text" inputmode="numeric" placeholder="0"
              #drawerMontoInputEl
              class="cq-monto-input"
              [class.editable]="drawerOpcion === 'abono'"
              [readonly]="drawerOpcion !== 'abono'"
              [value]="drawerMontoInput"
              (input)="drawerOnMontoInput(drawerMontoInputEl)">
          </div>
          <div class="cq-monto-error" *ngIf="drawerMontoError">{{ drawerMontoError }}</div>
        </div>

        <div class="cq-opciones">
          <div class="cq-opcion" [class.selected]="drawerOpcion === 'total'" (click)="drawerSeleccionarOpcion('total')">
            <div class="cq-op-radio" [class.checked]="drawerOpcion === 'total'"></div>
            <div class="cq-op-body">
              <div class="cq-op-title">Pagar el total</div>
              <div class="cq-op-desc">{{ fmt(drawerFacturaSeleccionada.total) }}</div>
            </div>
          </div>
          <div class="cq-opcion" [class.selected]="drawerOpcion === 'abono'" (click)="drawerSeleccionarOpcion('abono')">
            <div class="cq-op-radio" [class.checked]="drawerOpcion === 'abono'"></div>
            <div class="cq-op-body">
              <div class="cq-op-title">Realizar un abono</div>
              <div class="cq-op-desc">Ingresa el monto que quieres pagar.</div>
            </div>
          </div>
        </div>

        <div class="cq-resumen">
          <div class="cq-res-row" *ngIf="drawerOpcion === 'abono' && drawerMontoParseado() > 0 && drawerSaldoPendiente() > 0">
            <span class="cq-res-label">Quedará un saldo pendiente</span>
            <span class="cq-res-val">{{ fmt(drawerSaldoPendiente()) }}</span>
          </div>
          <div class="cq-res-row cq-res-highlight">
            <span class="cq-res-label">Disponible post pago</span>
            <span class="cq-res-val">{{ drawerMontoParseado() > 0 ? fmt(drawerDisponiblePostPago()) : '—' }}</span>
          </div>
        </div>
      </div>

      <!-- ESTADO: LOADER -->
      <div class="drawer-loader" *ngIf="drawerEstado === 'loader'">
        <div class="spinner spinner-sm"></div>
        <div class="loading-title">Procesando…</div>
        <div class="loading-sub">Un momento por favor</div>
      </div>

      <!-- ESTADO: VERIFICACIÓN -->
      <div class="drawer-verificacion" *ngIf="drawerEstado === 'verificacion'">
        <div class="val-icon"><span class="material-symbols-outlined">hourglass_top</span></div>
        <div class="val-eyebrow">Comprobante recibido</div>
        <div class="val-title">Estamos verificando tu transferencia</div>
        <p class="val-desc">Revisaremos que el dinero haya ingresado correctamente a Simpli. Cuando esté listo, lo verás disponible en tu inicio.</p>
        <div class="val-info-box">Te avisaremos cuando tu dinero esté disponible para usarlo.</div>
      </div>

    </div>

    <div class="drawer-footer" *ngIf="drawerEstado === 'comprobante' || drawerEstado === 'facturas' || drawerEstado === 'monto' || drawerEstado === 'verificacion'">
      <button class="drawer-footer-btn" *ngIf="drawerEstado === 'comprobante'" [disabled]="!drawerArchivoSubido" (click)="drawerIrFacturas()">
        Siguiente <span class="material-symbols-outlined">arrow_forward</span>
      </button>
      <button class="drawer-footer-btn" *ngIf="drawerEstado === 'facturas'" [disabled]="!drawerFacturaSeleccionada" (click)="drawerIrMonto()">
        Siguiente <span class="material-symbols-outlined">arrow_forward</span>
      </button>
      <button class="drawer-footer-btn" *ngIf="drawerEstado === 'monto'" [disabled]="!drawerPuedeConfirmar()" (click)="drawerConfirmarPago()">
        Confirmar pago <span class="material-symbols-outlined">check</span>
      </button>
      <button class="drawer-footer-btn drawer-footer-btn-outline" *ngIf="drawerEstado === 'verificacion'" (click)="drawerVolverInicio()">
        Volver al inicio
      </button>
    </div>

  </div>

  </div>

</div>
